import React, { useState } from "react";

export type ProductSwatch = {
  colourName: string;
  colourCode: string;
  handle: string;
  isCurrentProduct: boolean;
  productLegacyResourceId: 9651134038306;
  published: boolean;
  imageUrl?: string;
  images: string[];
  colourHex?: string;
  colourGroup?: string;
  styleCode: string;
  title: string;
  tags: string[];
  maxPrice: 200;
  minPrice: 200;
};

const SWATCH_IMAGE_PLACEHOLDER =
  "https://cdn.shopify.com/s/files/1/0919/0116/5858/files/096f8e84-4843-4737-a536-07b566d7c33f_600x600.jpg?v=1742331151";

function Swatch({
  swatch,
  resultHandle,
  updateSwatch,
}: {
  swatch: ProductSwatch;
  resultHandle: string;
  updateSwatch: (handle: string) => void;
}) {
  const isSelected: boolean = swatch.handle === resultHandle;
  const isActive = swatch.published;
  const handleSwatchUpdate = (): void => updateSwatch(swatch.handle);

  const swatchFilePathUrl = window.SHOPIFY_DATA.assets.filePath;
  const swatchImageString = swatch.tags.find((tag) => tag.includes("x-swatch:"))?.replace("x-swatch:", "");
  const swatchUrl = swatchFilePathUrl?.replace("swatch-placeholder_48x48", swatchImageString);

  if (!isActive) return null;

  return (
    <button onClick={handleSwatchUpdate} className="max-h-6 max-w-6">
      <img src={swatchImageString ? swatchUrl : swatchFilePathUrl} className="h-full w-full object-cover" />
      <div
        data-ui={isSelected}
        className="mt-1 h-fit w-full border-b-2 border-neutrals-black opacity-0 transition-all duration-200 group-hover:opacity-20 ui-[true]:opacity-100 ui-[true]:group-hover:opacity-100"
      ></div>
    </button>
  );
}

const SWATCH_CUTOFF = 4;

export function CardProductSwatches({
  swatches,
  updateSwatch,
  resultHandle,
}: {
  resultHandle: string;
  swatches: ProductSwatch[];
  updateSwatch: (handle: string) => void;
}) {
  const [showAll, setShowAll] = useState<boolean>(false);
  const toggleShowAll = () => setShowAll((t: boolean) => !t);

  const activeSwatches = swatches.reduce((acc: ProductSwatch[], swatch: ProductSwatch) => {
    if (!swatch?.published) return acc;
    acc.push(swatch);
    return acc;
  }, []);

  const remainingSwatches: number = activeSwatches.slice(SWATCH_CUTOFF, activeSwatches.length).length;
  const swatchesResults: ProductSwatch[] = showAll ? activeSwatches : activeSwatches.slice(0, SWATCH_CUTOFF);

  if (!activeSwatches.length) return null;

  return (
    <div className="flex flex-row flex-wrap gap-1">
      {swatchesResults.map((swatch: ProductSwatch) => {
        return (
          <Swatch
            swatch={swatch}
            resultHandle={resultHandle}
            updateSwatch={updateSwatch}
            key={swatch.productLegacyResourceId}
          />
        );
      })}
      {!showAll && remainingSwatches >= 1 && (
        <button onClick={toggleShowAll}>
          <span className="text-label">+{remainingSwatches}</span>
        </button>
      )}
    </div>
  );
}
